
/**
 * Process wildcards in pattern: ?? = exactly 2 chars, * = any number, ? = 0 or 1 char
 * @param {string} pattern - Pattern string (may contain escaped special chars)
 * @returns {string} - Pattern with wildcards replaced
 */
export function processWildcards(pattern) {
    if (!pattern || typeof pattern !== 'string') return pattern;
    const reAllLetters = window.reAllLetters || 'A-Za-zА-Яа-яЁё';
    let result = pattern;
    // Replace ?? first (before single ?) - exactly 2 characters
    result = result.replace(/\?\?/g, `[${reAllLetters}]{2}`);
    // Replace escaped ?* (already escaped as \? or \*) - these become single char wildcards
    result = result.replace(/\\([\?\*])/g, `[${reAllLetters}]$1`);
    // Replace unescaped * (for word patterns) - any number of characters
    // Use a simple approach: replace * that is not preceded by \
    result = result.replace(/([^\\])\*/g, `$1[${reAllLetters}]*`);
    // Handle * at the start of string
    if (result.startsWith('*')) {
        result = `[${reAllLetters}]*` + result.substring(1);
    }
    // Replace unescaped ? (for word patterns) - 0 or 1 character
    result = result.replace(/([^\\])\?/g, `$1[${reAllLetters}]?`);
    // Handle ? at the start of string
    if (result.startsWith('?')) {
        result = `[${reAllLetters}]?` + result.substring(1);
    }
    return result;
}

/**
 * Helper function to add date pattern with wildcard processing
 * @param {Array} patternsArray - Array to add pattern to
 * @param {Set} patternsSet - Set to track duplicates
 * @param {string} patternStr - Pattern string to add
 */
export function addDatePatternWithWildcards(patternsArray, patternsSet, patternStr) {
    // Process wildcards in date patterns
    const processedPattern = processWildcards(patternStr);
    if (!patternsSet.has(processedPattern)) {
        patternsArray.push({ pattern: processedPattern, boost: 1, flags: 'i' });
        patternsSet.add(processedPattern);
    }
}

